import styled from "styled-components";

export const StyledContentWrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    position: relative;
`;

export const StyledScrollWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    max-height: 100%;
    min-height: 100%;
`;
export const StyledScrollContainer = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    overflow: auto;
    position: relative;
    max-height: 100%;
    min-height: 100%;
    width: 100%;
`;
export const StyledScrollShadowHiderItem = styled.div`
    width: 100%;
    height: 8px;
    min-height: 8px;
    max-height: 8px;
    background-color: #fff;
    z-index: 9999;
    position: relative;
`;
export const StyledScrollShadowItem = styled.div`
    width: 100%;
    height: 8px;
    position: absolute;
    bottom: -8px;
    z-index: 99;
    box-shadow:
        0 0 8px 0 rgba(0, 0, 0, 0.12),
        0 8px 8px 0 rgba(0, 0, 0, 0.24);
`;
